import { Injectable } from '@angular/core';
import { Post } from './post'
import { Observable }from 'rxjs'
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globals from './globals';

@Injectable()
export class PostService {
  savePostUrl:string = globals.URL+"/backend/save_post.php"
  deletePostUrl:string = globals.URL+"/backend/delete_post.php"
  getPostsUrl:string = globals.URL+"/backend/get_posts.php"
  
  constructor(private http: HttpClient) { }
  getPosts(category?:string): Observable<Post[]>{
  	console.log(category)
    if(!category)
  	 return this.http.get<Post[]>(this.getPostsUrl)
    return this.http.get<Post[]>(this.getPostsUrl+"?category="+category)
  }
  savePost(post:any): Observable<any>{
    console.log(post)
    let formData:FormData = new FormData();
    formData.append('id', post.id);
    formData.append('category', post.category);
    formData.append('type', post.type);
    //let headers = new Headers();
    /** In Angular 5, including the header Content-Type can invalidate your request */
    //headers.append('Content-Type', 'multipart/form-data');
    //headers.append('Accept', 'application/json');
    //let options = new RequestOptions({ headers: headers });
    var observable = this.http.post(this.savePostUrl, formData)
    return observable
  }
  deletePost(id:number): Observable<any>{
    let formData:FormData = new FormData();
    formData.append('id', id+"");
    return this.http.post(this.deletePostUrl, formData)
  }
}



// WEBPACK FOOTER //
// ./src/app/post.service.ts